package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.CollapsibleDemo

@Page
@Composable
fun CollapsiblePage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/collapsible.md", mapOf("title" to listOf("Collapsible"), "description" to listOf("An interactive component which expands/collapses a panel."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/collapsible"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/collapsible#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.ChevronsUpDown
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h4
import react.dom.html.ReactHTML.span
import react.useState
import shadcn.ui.components.Button
import shadcn.ui.components.Collapsible
import shadcn.ui.components.CollapsibleContent
import shadcn.ui.components.CollapsibleTrigger
import web.cssom.ClassName

val CollapsibleDemo = FC<Props> {
    val (isOpen, setIsOpen) = useState(false)

    Collapsible {
        open = isOpen
        onOpenChange = setIsOpen
        className = ClassName("w-[350px] space-y-2")

        div {
            className = ClassName("flex items-center justify-between space-x-4 px-4")
            h4 {
                className = ClassName("text-sm font-semibold")
                +"@peduarte starred 3 repositories"
            }
            CollapsibleTrigger {
                asChild = true
                Button {
                    variant = "ghost"
                    size = "sm"
                    className = ClassName("w-9 p-0")
                    ChevronsUpDown { className = ClassName("h-4 w-4") }
                    span {
                        className = ClassName("sr-only")
                        +"Toggle"
                    }
                }
            }
        }
        div {
            className = ClassName("rounded-md border px-4 py-3 font-mono text-sm")
            +"@radix-ui/primitives"
        }
        CollapsibleContent {
            className = ClassName("space-y-2")
            div {
                className = ClassName("rounded-md border px-4 py-3 font-mono text-sm")
                +"@radix-ui/colors"
            }
            div {
                className = ClassName("rounded-md border px-4 py-3 font-mono text-sm")
                +"@stitches/react"
            }
        }
    }
}"""){ 
 CollapsibleDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Collapsible
import shadcn.ui.components.CollapsibleContent
import shadcn.ui.components.CollapsibleTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""Collapsible {
    CollapsibleTrigger { +"Can I use this in my project?" }
    CollapsibleContent {
        + "Yes.Free to use for personal and commercial projects . No attribution required."
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
